import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

type ButtonProps = Readonly<{
  icon: React.ReactNode;
  label?: string; // ← optional
  active: boolean;
  onPress: () => void;
}>;

const NavItem = ({ icon, label, active, onPress }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Pressable
      onPress={onPress}
      className="flex-1 items-center justify-center py-2"
    >
      <View className={`items-center ${active ? "opacity-100" : "opacity-60"}`}>
        {icon}
        {label && (
          <Text
            className={`text-xs mt-1 ${
              active ? "font-semibold text-primary" : "font-medium text-slate"
            }`}
          >
            {t(label)}
          </Text>
        )}
      </View>
    </Pressable>
  );
};

export default NavItem;
